import client, { handleError } from '../axios-config'

const controllerPrefix = '/mailing'

const getOptOut = async function (optOutId) {
  try {
    const response = await client.get(`${controllerPrefix}/optOut/${optOutId}`)
    return response.data
  } catch (error) {
    return handleError(error)
  }
}

const getOptOutIdAcoustic = async function (acousticMailingId) {
  try {
    const response = await client.get(`${controllerPrefix}/optOut/acoustic/${acousticMailingId}`)
    return response.data
  } catch (error) {
    return handleError(error)
  }
}

const optOutRecipient = async function (data) {
  try {
    const response = await client.post(`${controllerPrefix}/optOut/recipient`, data)
    return response.data
  } catch (error) {
    return handleError(error)
  }
}

export const mailingService = {
  getOptOut,
  getOptOutIdAcoustic,
  optOutRecipient
}
